import { useEffect, useRef } from 'react';

/**
 * Surfaces an unread-results badge on the command-bar Copilot button when the
 * assistant finishes streaming while the panel is closed.
 *
 * Rules:
 * - Fires only on the streaming → not-streaming transition (edge, not level).
 * - Only marks unread when the panel is closed — if it's open, the user is
 *   already looking at the results.
 * - Never clears unread state itself; call sites clear it when the panel is
 *   explicitly opened by the user.
 *
 * Extracted from `WorkflowDesignerWithCode` as part of the Copilot rail
 * removal so this side effect can be unit-tested in isolation.
 */
export function useCopilotUnreadBadge(
  isStreaming: boolean,
  isChatSidebarOpen: boolean,
  setHasUnreadMessages: (value: boolean) => void
): void {
  const prevIsStreamingRef = useRef(isStreaming);

  useEffect(() => {
    if (prevIsStreamingRef.current && !isStreaming && !isChatSidebarOpen) {
      setHasUnreadMessages(true);
    }
    prevIsStreamingRef.current = isStreaming;
  }, [isStreaming, isChatSidebarOpen, setHasUnreadMessages]);
}
